/*
css
.accordion {
}

.accordion__body {
  overflow: hidden;
  transition: max-height 0.2s ease-out;
  max-height:0;
}


*/

import selectParent from 'select-parent'

class Accordion {
	constructor(element, options) {
		this.options = {
			setHash: false,
			activeClass: 'is-active',
			toggleSync: false,
			rowClass: '.accordion__row',
			headerClass: '.accordion__header',
			bodyClass: '.accordion__body',
			onChanged: () => {},
		}
		Object.assign(this.options, options)

		this.element = element
		// this.rows = Array.from(element.querySelectorAll(this.options.rowClass))
		this.rows = Array.from(
			element.querySelectorAll(this.options.rowClass)
		).map((row) => {
			return {
				el: row,
				isDisabled: row.classList.contains('is-disabled'),
				id: row.getAttribute('id'),
				elBody: row.querySelector(this.options.bodyClass),
			}
		})

		// initiate listeners

		this.onClickBounded = this.onClick.bind(this)
		this.element.addEventListener('click', this.onClickBounded)
		this.init()
	}

	getRows() {
		return this.rows.map((row) => row.el)
	}

	expandAll() {
		this.rows.forEach((row) => {
			this.expandRow(row.el)
		})
	}

	collapseAll() {
		this.rows.forEach((row) => {
			this.collapseRow(row.el)
		})
	}

	// Sets the browser hash
	setHash(id) {
		if (id && id !== '') {
			history.replaceState({}, null, `#${id}`)
			// window.location.hash = `#${id}`
		}
	}
	expandRow(row, noHistory) {
		if (this.options.setHash && !noHistory) {
			let id = row.getAttribute('id')
			if (id) {
				this.setHash(id)
			}
		}
		row.classList.add(this.options.activeClass)

		let rowBody = row.querySelector(this.options.bodyClass)
		rowBody.style.maxHeight = rowBody.scrollHeight + 'px'

		setTimeout(this.options.onChanged, 0)
	}

	expandRowById(id) {
		let row = this.rows.find((o) => {
			return o.id == id
		})

		if (!row) return

		this.expandRow(row.el, true)
	}

	collapseRow(row) {
		// if (triggerCallback) {
		//   this.options.onCollapseRow()
		// }

		row.classList.remove(this.options.activeClass)
		let rowBody = row.querySelector(this.options.bodyClass)
		// if max height is not set
		if (!rowBody.style.maxHeight) {
			rowBody.style.maxHeight = rowBody.scrollHeight + 'px'
		}
		setTimeout(() => {
			rowBody.style.maxHeight = '0px'
		}, 0)

		setTimeout(this.options.onChanged, 0)
	}

	toggleRow(row) {
		if (row.classList.contains('is-disabled')) return
		if (!row.classList.contains(this.options.activeClass)) {
			if (this.options.toggleSync) {
				this.expandAll()
			} else {
				this.expandRow(row)
			}
		} else {
			if (this.options.toggleSync) {
				this.collapseAll()
			} else {
				this.collapseRow(row)
			}
		}
	}

	onClick(ev) {
		let header = selectParent(this.options.headerClass, ev.target)
		if (
			!header &&
			ev.target.classList.contains(this.options.headerClass.substr(1))
		) {
			header = ev.target
		}

		if (!header) return

		let row = selectParent(this.options.rowClass, ev.target)

		this.toggleRow(row)
	}
	setBaseMaxHeight() {
		this.rows.forEach((row) => {
			if (row.el.classList.contains(this.options.activeClass)) {
				row.elBody.style.maxHeight = row.elBody.scrollHeight + 'px'
			} else {
				row.elBody.style.maxHeight = '0px'
			}
		})
	}

	reset() {
		this.element.removeEventListener('click', this.onClickBounded)
		this.rows.forEach((row) => {
			row.el.classList.remove(this.options.activeClass)
			row.elBody.style.maxHeight = 'auto'
			// remove maxHeight from the style
			row.elBody.style.maxHeight = ''
		})

		// el.classList.remove('is-enabled')
		// enabled = false
	}

	destroy() {
		// this.collapseAll()
		this.reset()
		// this.rows.forEach((row) => {

		//   console.log(row)
		//   row.elBody.style.maxHeight = '200px'
		// })
		// this.element.removeEventListener('click', this.onClickBounded)
	}

	init() {
		this.setBaseMaxHeight()
	}
}

export { Accordion }
